import { Component, Input } from '@angular/core';
import { Course } from '@core/models/course.model';
import { QuestionSubmissionService } from '@core/services/question-submission/question-submission.service';
import { ActivityNextItem } from '@core/models/common/activity-next-item.model';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-single-course-card',
  templateUrl: './single-course-card.component.html',
  styleUrl: './single-course-card.component.css',
})
export class SingleCourseCardComponent {
  @Input() course?: Course;
  @Input() is_myCourse: boolean = false;
  nextItem: ActivityNextItem | null = null;
  private subscriptions = new Subscription();

  constructor(
    private readonly questionSubmissionService: QuestionSubmissionService,
    private readonly router: Router
  ) {}

  startCourse(courseUuid: string): void {
    const nextItemSub = this.questionSubmissionService.getNextItem(courseUuid).subscribe({
      next: (nextItem) => {
        this.nextItem = nextItem;

        if (!this.nextItem) return;

        if (this.nextItem.item_type === 'questionSet') {
          this.router.navigate([`/chapter/${courseUuid}/test/${this.nextItem.item_uuid}`]);
        } else if (this.nextItem.item_type === 'lesson') {
          this.router.navigate([`/chapter/${courseUuid}/lesson/${this.nextItem.item_uuid}`]);
        } else if (this.nextItem.item_type === 'certificate') {
          this.router.navigate([`/courses/${courseUuid}/certificate`]);
        } else if (this.nextItem.item_type === 'certified') {
          if (this.nextItem.item_uuid) {
            window.open(this.nextItem.item_uuid, '_blank');
          }
        }
      },
      error: () => {
        this.nextItem = null;
      },
    });
    this.subscriptions.add(nextItemSub);
  }

  isExpiringSoon(expiredAt: string | null | undefined): boolean {
    if (!expiredAt) return false;
    const expiryDate = new Date(expiredAt).getTime();
    const now = Date.now();
    const diffInDays = (expiryDate - now) / (1000 * 60 * 60 * 24);
    return diffInDays >= 0 && diffInDays <= 30;
  }

  formatAvailability(start?: string | null, end?: string | null): string {
    if (!start && !end) {
      return 'N/A';
    }

    const formattedStart = start ? this.formatDate(start) : 'N/A';
    const formattedEnd = end ? this.formatDate(end) : 'N/A';

    return `${formattedStart} – ${formattedEnd}`;
  }

  formatDate(dateStr: string | null | undefined): string {
    if (!dateStr) {
      return 'N/A';
    }

    return new Date(dateStr).toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    });
  }

  shouldShowButton(): boolean {
    if (!this.course) return false;

    const isCompleted = this.course?.participations?.[0]?.progress === 100;
    const isExpired =
      this.course?.expired_at && new Date(this.course.expired_at).getTime() < Date.now();

    if (this.is_myCourse && (isCompleted || isExpired)) {
      return false;
    }

    return true;
  }

  isExpired() {
    if (!this.course?.expired_at) {
      return false;
    }

    return new Date(this.course.expired_at).getTime() < Date.now();
  }
}
